var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "svg-user__a",
  d: "M15.9 12.55A5.5 5.5 0 0 1 19 17.5a.5.5 0 0 1-.146.354c-.29.289-.852.698-1.704 1.098C15.756 19.608 14.043 20 12 20s-3.756-.392-5.15-1.048c-.852-.4-1.414-.81-1.704-1.098A.5.5 0 0 1 5 17.5a5.5 5.5 0 0 1 3.1-4.95.5.5 0 1 1 .436.9 4.5 4.5 0 0 0-2.53 3.828 4.8 4.8 0 0 0 .17.13c.298.216.664.435 1.1.64 1.262.594 2.83.952 4.724.952 1.894 0 3.462-.358 4.725-.952a6.776 6.776 0 0 0 1.098-.64 4.8 4.8 0 0 0 .172-.13 4.5 4.5 0 0 0-2.532-3.828.5.5 0 0 1 .436-.9ZM12 4a4 4 0 0 1 4 4c0 2.37-1.885 5-4 5s-4-2.63-4-5a4 4 0 0 1 4-4Zm0 1a3 3 0 0 0-3 3c0 1.877 1.523 4 3 4s3-2.123 3-4a3 3 0 0 0-3-3Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-user__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-user__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-user__a",
  fill: "#7F7F7F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#svg-user__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export default ForwardRef;